module.exports = __webpack_public_path__ + "static/logo-ue-cap-rischio-f8ee77badcbae6c87360a519ed3a4e8b.png";